import { IModuleStore } from "redux-dynamic-modules";
import { PiletApi, PiletMetadata } from "piral-core";
import { PiletLanguageApi } from "./plugins/language/extendApi/LanguageExtendApi";
import { PiletFormPageLayoutApi } from "./plugins/FormPageLayout/FormPageLayoutExtendApi";
import { OpenCakPiletFeatureToggleApi } from "./plugins/featureToggle/extendApi/FeatureToggleExtendApi";

export const createMyShellApi = (_store: IModuleStore<unknown>, _target: PiletMetadata) => ({});

export function extendApi(store: IModuleStore<unknown>) {
  return () => (api: PiletApi, target: PiletMetadata) => ({
    ...api,
    ...createMyShellApi(store, target)
  });
}

export type OpenCakApi = ReturnType<typeof createMyShellApi>;

declare module "piral-core/lib/types/custom" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface PiletCustomApi
    extends OpenCakApi,
      OpenCakPiletFeatureToggleApi,
      PiletLanguageApi,
      PiletFormPageLayoutApi {}
}
